import React, { ReactElement, useMemo } from 'react';
import { Navigate } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { Routes } from '../../../routes';
import { UserResponseModel } from '../../../models/users/UserResponseModel';
import { IState } from '../../../store/IState';
import {
	INotifierService,
	NotifierService
} from '../../../services/notifierService';
import { ApplicationSections, UserRolesSectionsAssigned, UserSecurityRoles,  } from '../../../shared/userSecurityRoles';

export interface IPrivateRouteProps {
	sectionName: ApplicationSections;
	children: ReactElement;
}

export const PrivateRoute = ({
	sectionName,
	children
}: IPrivateRouteProps): JSX.Element => {
	const notifierService: INotifierService = useMemo(
		() => new NotifierService(),
		[]
	);

	const user: UserResponseModel | undefined = useSelector(
		(state: IState) => state.UserReducer.userDetails
	);

  const getUserAllowedSections = () => {
    if(!user){
      return [];
    }

    if(user.securityRoleCode === UserSecurityRoles.MarketShareUserRoleCode){
      return UserRolesSectionsAssigned.marketShareUserSections.applicationSections;
    }

    if(user.securityRoleCode === UserSecurityRoles.MarketShareAdminRoleCode){
      return UserRolesSectionsAssigned.marketShareAdminSections.applicationSections;
    }

    if(user.securityRoleCode === UserSecurityRoles.ServiceShareUserRoleCode){
      return UserRolesSectionsAssigned.serviceShareUserSections.applicationSections;
    }

    if(user.securityRoleCode === UserSecurityRoles.ServiceShareAdminRoleCode){
      return UserRolesSectionsAssigned.serviceShareAdminSections.applicationSections;
    }

    return [];
  }

	const userAllowedSections = getUserAllowedSections();

  const userHasAccess = userAllowedSections.includes(sectionName);

	if (!userHasAccess) {
		return <Navigate to={{ pathname: Routes.home.getPath() }} />;
	}

	return children;
};
